export enum CommunicationMediaKind {
  Image = 0,
  Document = 1,
  Video = 2,
}

export interface CommunicationAttachment {
  id: string;
  kind: CommunicationMediaKind;
  fileName: string;
  contentType: string;
  size: number;
  url: string;
}
